import QRCode from 'react-qr-code'
import styled from 'styled-components'
import { backgroundOrange, blackOrange, darkOrange, mutedGrey, orange, white } from '@/theme/colors'
import { shadows, radii, media } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'

export const Panel = styled.section`
	padding: 44px 44px 40px;
	display: flex;
	flex-direction: column;

	${media.tablet} {
		padding: 34px 30px;
	}
`

export const PanelTitle = styled.h2`
	${text.display}
	line-height: ${leading.tight};
	color: ${blackOrange};
	margin: 0;
`

export const GoogleSlot = styled.div`
	margin-top: 34px;
`

export const Divider = styled.div`
	display: flex;
	align-items: center;
	gap: 14px;
	margin: 30px 0;
	color: ${mutedGrey};
	${text.eyebrow}

	&::before,
	&::after {
		content: '';
		flex: 1;
		height: 1px;
		background: ${orange}29;
	}
`

export const QrRow = styled.div`
	display: flex;
	align-items: center;
	gap: 18px;
	background: ${backgroundOrange};
	border: 1px solid ${orange}1f;
	border-radius: ${radii.card};
	padding: 16px;
`

export const QrTile = styled.div`
	width: 108px;
	height: 108px;
	flex: none;
	background: ${white};
	border-radius: ${radii.inner};
	padding: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: ${shadows.inner};
`

export const QrCodeImage = styled(QRCode)`
	display: block;
	width: 100%;
	height: 100%;
`

export const QrText = styled.div`
	b {
		display: block;
		${text.label}
		color: ${blackOrange};
	}

	p {
		margin: 5px 0 0;
		font-size: ${fontSizes.small};
		line-height: ${leading.body};
		color: ${darkOrange};
		text-wrap: pretty;
	}
`

export const Foot = styled.div`
	margin-top: auto;
	padding-top: 34px;
	font-size: ${fontSizes.small};
	color: ${darkOrange};
	text-align: center;

	a {
		${text.labelSm}
		color: ${darkOrange};
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}
`

